// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Initialize Google Analytics
export const initGA = () => {
  // GA is already initialized in index.html
  console.log('Google Analytics initialized with ID: G-7D462NEVNR');
};

// Track page views
export const trackPageView = (page_title: string, page_location: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-7D462NEVNR', {
      page_title,
      page_location,
    });
  }
};

// Track custom events
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user authentication events - UPDATED TO INCLUDE ACCOUNT_DELETED
export const trackAuth = (action: 'login' | 'signup' | 'logout' | 'account_deleted') => {
  trackEvent(action, 'authentication', action);
};

// Track food-related events
export const trackFood = (action: string, label?: string) => {
  trackEvent(action, 'food', label);
};

// Track subscription events
export const trackSubscription = (action: string, label?: string) => {
  trackEvent(action, 'subscription', label);
};

// Track user engagement
export const trackEngagement = (action: string, label?: string) => {
  trackEvent(action, 'engagement', label);
};

// Track errors
export const trackError = (error: string, page: string) => {
  trackEvent('error', 'application', `${page}: ${error}`);
};

// Track conversions
export const trackConversion = (action: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'G-7D462NEVNR',
      event_category: 'conversion',
      event_label: action,
      value: value,
    });
  }
};

// Track account management events
export const trackAccountManagement = (action: 'profile_updated' | 'password_changed' | 'account_deleted' | 'data_exported' | 'kitchen_created' | 'kitchen_updated' | 'kitchen_deleted') => {
  trackEvent(action, 'account_management', action);
};